import { render, staticRenderFns } from "./ConfirmMailMobile.vue?vue&type=template&id=bd71ce4c&scoped=true&"
import script from "./ConfirmMailMobile.vue?vue&type=script&lang=js&"
export * from "./ConfirmMailMobile.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmMailMobile.vue?vue&type=style&index=0&id=bd71ce4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd71ce4c",
  null
  
)

export default component.exports